module.exports = __webpack_public_path__ + "static/media/product_2.74f23622.png";